<div *ngIf="machine" class="w-full h-full">
  <div class="h-full grid">
    <div class="flex flex-column col-12 lg:col-6"
         [ngClass]="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES') ? 'xl:col-4' : 'xl:col-6'">
      <div class="grid">
        <div class="flex flex-column col-6">
          <img [src]="machine.model.image" [alt]="machine.model.modelName" class="image-details align-self-center"
               [ngClass]="{'img-deleted': machine.deleted}"/>
        </div>
        <div class="flex flex-column col-6">
          <div class="mb-3">
            <h4 class="primary-color cursor-pointer mb-0 inline-block" [routerLink]="'/machines/' + machine.machineUuid + '/details'">{{machine.alias}}</h4>
            <button
              [routerLink]="'/machines/' + machine.machineUuid + '/details'"
              pButton
              class="p-button-link p-button-lg ml-1 py-0 align-self-center"
              icon="pi pi-external-link"
              iconPos="right"
            ></button>
            <hr>
          </div>
          <h5 class="mt-0 font-semibold">{{machine.model.modelName}}</h5>
          <p><b>{{ 'attribute.serialShort' | transloco}}: </b> {{machine.serial}}</p>
          <div class="mt-4">
            <button pButton
                    class="p-button-link p-button-lg button-details align-self-center ml-1"
                    icon="pi pi-chart-bar"
                    [routerLink]="'/machines/' + machine.machineUuid + '/details/charts'"
            ></button>
            <button *ngIf="authGuard.hasPermission('PERMISSION_VIEW_ALARMS')"
                    pButton
                    class="p-button-link p-button-lg button-details align-self-center ml-1"
                    icon="pi pi-exclamation-triangle"
                    [routerLink]="'/machines/' + machine.machineUuid + '/details/issues'"
            ></button>
            <button *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')"
                    pButton
                    class="p-button-link p-button-lg button-details align-self-center ml-1"
                    icon="pi pi-cog"
                    [routerLink]="'/machines/' + machine.machineUuid + '/details/config'"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-column col-12 lg:col-6 align-items-center"
         [ngClass]="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES') ? 'xl:col-4' : 'xl:col-6'">
      <div class="mb-3">
        <h4 class="mb-3">{{ 'misc.overview.machineStatus' | transloco }}</h4>
        <hr>
      </div>
      <div class="mb-3">
        <h5 class="font-semibold m-auto text-center" *ngIf="!machine.telemetryData?.lastValueReported">
          {{'empty.lastValueReported' | transloco}}
        </h5>
        <h5 class="text-primary font-semibold m-auto text-center" *ngIf="machine.telemetryData?.lastValueReported">
          {{machine.telemetryData.lastValueReported | date:'long': authGuard.getOffset(): authGuard.getLanguage()}}
        </h5>
      </div>
      <div class="grid">
        <div class="flex flex-column col-6 align-self-center">
          <div class="col-12">
            <b>{{ 'attribute.squeezedFruits' | transloco}} ({{'misc.thisMonth' | transloco}}): </b>
            <span *ngIf="machine.telemetryData?.squeezedFruitsLastMonth != null && machine.telemetryData?.squeezedFruitsLastMonth != undefined">{{machine.telemetryData.squeezedFruitsLastMonth}}</span>
            <span *ngIf="machine.telemetryData?.squeezedFruitsLastMonth == null || machine.telemetryData?.squeezedFruitsLastMonth == undefined">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.machineAge' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.machineAge != null && machine.telemetryData?.machineAge != undefined">
                        {{machine.telemetryData.machineAge}} {{'time.years' |transloco}}</span>
            <span *ngIf="machine.telemetryData?.machineAge == null || machine.telemetryData?.machineAge == undefined">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'misc.overview.workingHours' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.workHours != null && machine.telemetryData?.workHours != undefined">
                            {{machine.telemetryData.workHours}}&nbsp;{{'time.hours' |transloco}}</span>
            <span *ngIf="machine.telemetryData?.workHours == null || machine.telemetryData?.workHours == undefined">N/A</span>
          </div>
          <div class="col-12">
            <b>{{ 'attribute.connection' | transloco}}: </b>
            <span *ngIf="machine.telemetryData?.isOn">{{'attribute.connected' | transloco}}</span>
            <span *ngIf="!machine.telemetryData?.isOn">{{'attribute.disconnected' | transloco}}</span>
          </div>
        </div>
        <div class="flex flex-column col-6 align-self-center">
          <p-tag *ngIf="machine.telemetryData?.isPoweredOn" value="{{'attribute.on' | transloco}}" class="green-tag map-tag"></p-tag>
          <p-tag *ngIf="!machine.telemetryData?.isPoweredOn" value="{{'attribute.off' | transloco}}" class="gray-tag map-tag"></p-tag>
          <p-tag *ngIf="machine.telemetryData?.hasAlarms" value="{{'attribute.hasAlarms' | transloco}}"
                 class="red-tag map-tag cursor-pointer" [routerLink]="'/machines/' + machine.machineUuid + '/details/issues'"></p-tag>
          <p-tag *ngIf="!machine.telemetryData?.hasAlarms" value="{{'attribute.noAlarms' | transloco}}" class="green-tag map-tag"></p-tag>
          <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')">
            <p-tag *ngIf="machine.telemetryData?.hasEvents" value="{{'attribute.hasEvents' | transloco}}"
                   class="yellow-tag map-tag cursor-pointer" [routerLink]="'/machines/' + machine.machineUuid + '/details/issues'"></p-tag>
            <p-tag *ngIf="!machine.telemetryData?.hasEvents" value="{{'attribute.noEvents' | transloco}}" class="green-tag map-tag"></p-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-column col-12 lg:col-6 xl:col-4 align-items-center"
         *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')">
      <div class="mb-3">
        <h4 class="mb-3">{{ 'misc.overview.machineDetails' | transloco }}</h4>
        <hr>
      </div>
      <div>
        <div class="mb-3">
          <p style="margin:0;">
            <b>{{'misc.lastAlarm' | transloco}}: </b>
            <span *ngIf="lastAlarmDate">{{lastAlarmDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage()}}</span>
            <span *ngIf="!lastAlarmDate" class="font-italic">{{ 'empty.alarms' | transloco }}</span>
          </p>
          <p>
            <b>{{'misc.lastEvent' | transloco}}: </b>
            <span *ngIf="lastEventDate">{{lastEventDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage()}}</span>
            <span *ngIf="!lastEventDate" class="font-italic">{{ 'empty.events' | transloco }}</span>
          </p>
        </div>
        <div>
          <p>{{'misc.organizationData' | transloco}}:</p>
          <ul>
            <li class="line-height-3"><b>{{'attribute.name' | transloco}}: </b>{{machine.organization.name}} ({{machine.organization.orgCode}})</li>
            <li class="line-height-3"><b>{{'attribute.phone' | transloco}}: </b>
              <span *ngIf="machine.organization.phone">{{machine.organization.phone}}</span>
              <span *ngIf="!machine.organization.phone">N/A</span>
            </li>
            <li class="line-height-3"><b>{{'attribute.email' | transloco}}: </b>
              <span *ngIf="machine.organization.email">{{machine.organization.email}}</span>
              <span *ngIf="!machine.organization.email">N/A</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
